import React from 'react';
import PropTypes from "prop-types";
import { BottomLinkStyled  } from "./BottomLinkStyled.styled";

const BottomLink = ( { activeTab, className } ) => {

  const baseUrl = window.location.origin;

  return (
    <BottomLinkStyled>
      <a href={`${baseUrl}/myAccount/My-deliveries`} className={className}>
        View My deliveries
      </a>
    </BottomLinkStyled>
  );
}

export default BottomLink;

BottomLink.propTypes = {
  activeTab: PropTypes.string,
  className: PropTypes.string,
};